export default __webpack_public_path__ + "static/media/5.e8b3c853.gif";